import script from "./LocaleBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./LocaleBanner.vue?vue&type=script&setup=true&lang=js"

import "./LocaleBanner.vue?vue&type=style&index=0&id=72f5398a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f5398a"]])

export default __exports__